import { render, staticRenderFns } from "./business-vs.vue?vue&type=template&id=708d7a10&scoped=true&"
import script from "./business-vs.vue?vue&type=script&lang=ts&"
export * from "./business-vs.vue?vue&type=script&lang=ts&"
import style0 from "./business-vs.vue?vue&type=style&index=0&id=708d7a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708d7a10",
  null
  
)

export default component.exports